import React from 'react';
import { OfferRequisition } from '../../../../../../entities/v1/applicant_tracking/OfferRequisition';
import RequisitionCard from '../../../../../../components/ApplicantTracking/Requisition/RequisitionCard';
import styles from '../styles.module.scss';
import classNames from 'classnames';
import { OfferDocuments } from './OfferDocuments';
import { Signatories } from './Signatories';

interface PropTypes {
  offerRequisition: OfferRequisition;
}

export default function DocumentsAndSignatoryInfoCard(props: PropTypes) {
  return (
    <RequisitionCard
      title='Documents'
      className={classNames(styles['requisition-documents-card'], 'mt-4')}
      gap='4'
    >
      <OfferDocuments signableOffer={props.offerRequisition.signableOffer} />
      <Signatories
        signingLinks={props.offerRequisition.signableOffer.signingLinks}
      />
    </RequisitionCard>
  );
}
